import artwork41213 from "../../../assets/curation/5/41213.jpg";
import artwork256591 from "../../../assets/curation/5/256591.gif";
import artwork41372 from "../../../assets/curation/5/41372.gif";
import artwork61173 from "../../../assets/curation/5/61173.gif";
import artwork180919 from "../../../assets/curation/5/180919.jpg";
import artwork379329 from "../../../assets/curation/5/379329.jpg";
import artwork587969 from "../../../assets/curation/5/587969.gif";

const data = {
  title: "NEXUS",
  subtitle: "PRISMA #6",
  curated: "Curated by<br/>Hung Yu Hao",
  description: `<p>NEXUS - Although Herbert Marshall McLuhan and Friedrich Kittler held different views on the concept of media as "extensions of man" (Understanding Media: The Extensions of Man, Marshall McLuhan, 1964), they both point to the fact that the operation of human thought in media tends to be "mental information" in a particular system. In other words, in the digital age, any form of human life can be transformed into a new media context.</p>

  <p>Therefore, now that the Internet world is widespread, countless virtual channels are already involved in daily life, and the "discarnate man", who travels back and forth, the body can be seen as the deconstruction of centralized power, and the decentralized "spiritual values" converge in the virtual world, thus "retribalize" the structure of social groups in the digital realm.</p>

  <p>This exhibition collects the body parts in the NFT world, just as the decentralized consciousness extends to the digital frontier, exploring the multi-faceted cultural connotations of the real world, and the nodes of consciousness are also linked together to pave the road in the digital wilderness.</p>
  `,
  artists: [
    {
      artist: ["OlgaFeldman"],
      title: "AnAtomy Base 04",
      profile: ["tz1LYsPk7oUZ96prBgY8mmCuiPhxR9TMSD4i"],
      description: `04 — Care. Basic research on ability to represent human anatomy in vector. Series of 6 artworks.`,
      objktID: 41213,
      artwork: artwork41213,
    },
    {
      artist: ["wethefingers"],
      title: "FV033|the devil",
      profile: ["tz1X2CuZrr31CeXofhuQQSJny4DxyZL9FtxQ"],
      description: `We the fingers, are the vessels of energy. Together we dance to achieve a collective consciousness.`,
      objktID: 256591,
      artwork: artwork256591,
    },
    {
      artist: ["SonicChimes"],
      title: "One Hand, Many Hands",
      profile: ["tz1NsfhwjwuZnq9XfuNDyFnw6k6xUQYYCZtz"],
      description: `Artist: @sonicchimes "We are one." 1024 x 1024 px Animated`,
      objktID: 41372,
      artwork: artwork41372,
    },
    {
      artist: ["annaXmalina"],
      title: "⚘",
      profile: ["tz1Up3Uyj6PR3AkdsaXouhhetS3VdaTkW2Ro"],
      description: `I'm not a carrot plant (...) :: {2018} :: black & white version; collage animation :: @annaxmalina :: annamalina.com`,
      objktID: 61173,
      artwork: artwork61173,
    },
    {
      artist: ["Dib"],
      title: "Folded meat",
      profile: ["tz1MtbiHXodCpGSAh8hGw1Em6jsFgU8H1ipx"],
      description: `I wanted to thank everyone to the support so i'm minting this one for 0,2 tez.
      "carne dobrada" ink on paper`,
      objktID: 180919,
      artwork: artwork180919,
    },
    {
      artist: ["CERO_TRES"],
      title: "contact sheet 4 - v i o l e n c e [ white ed ]",
      profile: ["tz2WgvJDX6Q2gEhgm8NjSLa55Mgr4JMaKBka"],
      description: `abstract interpretation of emotions | from the series [ m o r e ] abstract thoughts of a hopeless romantic | generative art / 1080 x 1080 px | http://00000011.f3.studio/ | IG: @cero.tres_ TW: @C3RO_TRES`,
      objktID: 379329,
      artwork: artwork379329,
    },
    {
      artist: ["hsinhsin"],
      title: "Hands-2",
      profile: ["tz1aHdW3qf77hLFUYBZzqwtyKeJbnLxN4S8j"],
      description: `"In darkness, the hands and feet dance like a dialogue, which combines repetitive movements and music to create a new language within the space. During the video and music post-production process, the artist arranges arbitrary sign language to compose a free-association of new stories."`,
      objktID: 587969,
      artwork: artwork587969,
    },
  ],
};

export default data;
